import {Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {DcpKymaService} from '@app/services/dcp-kyma.service';
import {Observable} from 'rxjs';
import {G2ReviewList} from '../../../models/g2-review.model';
import {Product} from '@spartacus/core';
import {isPlatformBrowser} from '@angular/common';
import {CustomScrollingService} from '@app/services/custom-scrolling.service';
import {WriteReviewDialogService} from '../../review/write-review/write-review-dialog.service';

@Component({
  selector: 'dcp-hero-review',
  templateUrl: './hero-review.component.html'
})
export class HeroReviewComponent implements OnInit, OnDestroy {

  @Input() product: Product;
  reviews$: Observable<G2ReviewList>;
  private defaultHeaderOffset: number = 70;

  constructor(
    @Inject(PLATFORM_ID) public platformId: object,
    private kymaService: DcpKymaService,
    private scrollService: CustomScrollingService,
    public reviewDialogService: WriteReviewDialogService
  ) {
  }

  ngOnInit(): void {
    this.reviews$ = this.kymaService.getReviewsData();
  }

  ngOnDestroy(): void {
    this.kymaService.setReviewsData(null);
    this.reviews$ = null;
  }

  scrollToReviewSection() {
    if (isPlatformBrowser(this.platformId)) {
      const reviewSection: HTMLElement = document.getElementById('review-section');
      this.scrollService.scrollToElement(reviewSection, this.defaultHeaderOffset);
    }
  }
}
